import { cn } from '@/lib/utils';

interface ReferenceLoadingIndicatorProps {
  className?: string;
}

export const ReferenceLoadingIndicator = ({
  className,
}: ReferenceLoadingIndicatorProps) => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Loading reference"
    className={cn('flex min-h-0 flex-1 items-center justify-center', className)}
  >
    <div className="border-border border-t-foreground size-10 animate-spin rounded-full border-4" />
  </div>
);
